import { gql } from "graphql-tag"

const getEvaluaciones = gql`
  query periodos {
    creditos_periodosCargados
  }
`;

const getPeriodosAT = gql`
 query Query($idPlantilla: Int) {
    evaluaciones(idPlantilla: $idPlantilla) {
      id
      fechaContable
      idPlantilla
    }
  }
`;

const getData = gql`
  query Query($periodo: String!) {
    ahorros_sub_calculos(periodo: $periodo) {
      AHO_06 {
        cuentaAhorro
        numeroSocio
        saldoGestionTotal
        totalIntereses
      }
      AHO_07 {
        cuentaAhorro
        numeroSocio
        saldoGestion
        totalIntereses
      }
      AHO_08 {
        cuentaAhorro
        numeroSocio
        saldoGestion
        totalIntereses
      }
    }
  }
`;

const getATVarTemp = gql`
  query Query($idEvaluacion: Int!, $idVarTemp: String!) {
    detalleEvaluacionVarTemp(idEvaluacion: $idEvaluacion, idVarTemp: $idVarTemp) {
      idEvaluacion
      idVarTemp
      valor
    }
  }
`;

const setLimites = gql`
  mutation Update_ahorros_propiedades_adicionales($periodo: DateTime!, $institucionId: String, $propiedades: PropiedadesAhorrosInput!) {
    update_ahorros_propiedades_adicionales(periodo: $periodo, institucionID: $institucionId, propiedades: $propiedades) {
      periodo
      propiedades
    }
  }
`;

const getPropieties = gql`
  query Adicionales($periodo: String!, $institucionId: String) {
    ahorros_sub_calculos(periodo: $periodo) {
      adicionales(institucionID: $institucionId) {
        periodo
        propiedades
      }
    }
  }
`;

export {getEvaluaciones, getPeriodosAT, getData, getATVarTemp, setLimites, getPropieties}